import type { TemplateOnlyComponent } from '@ember/component/template-only';

export interface Signature {
  Args: {
    class?: string;
  };
  Element: SVGElement;
}

const WrHeartIconComponent: TemplateOnlyComponent<Signature> = <template>
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='16'
    height='16'
    viewBox='0 0 16 16'
    fill='none'
    class={{@class}}
    ...attributes
  >
    <path
      d='M15.6 5.115C15.4 3.015 13.5 1.115 11.4 1.015C10 0.915 8.8 1.315 7.9 2.215C5.9 0.615 3.3 0.615 1.5 2.315C-0.5 4.215 -0.5 7.215 1.5 9.215C1.6 9.315 1.8 9.615 2 9.715C2.1 9.815 2.2 9.915 2.2 9.915L2.3 10.015C2.7 10.515 3.1 11.015 3.5 11.515C4.4 12.615 5.3 13.715 6.2 14.815C6.6 15.315 7.1 15.515 7.7 15.515C8.3 15.515 8.8 15.315 9.2 14.815C9.6 14.415 10 13.915 10.3 13.515C11.3 12.315 12.3 11.115 13.4 9.815C13.5 9.715 13.8 9.415 13.8 9.415C13.8 9.415 14.1 9.115 14.3 8.915C15.3 7.915 15.8 6.615 15.6 5.115ZM12.9 8.515C12.7 8.715 12.5 8.915 12.4 9.015C11.3 10.315 10.3 11.515 9.3 12.715C8.9 13.115 8.6 13.615 8.2 14.015C8 14.215 7.9 14.215 7.7 14.215C7.6 14.215 7.4 14.115 7.2 13.915C6.3 12.815 5.4 11.715 4.5 10.615C4.2 10.215 3.8 9.715 3.3 9.215V9.115C3.2 9.015 3.1 8.915 3.1 8.915C3 8.715 2.9 8.615 2.8 8.515H5.2C5.7 8.515 6.3 8.215 6.6 7.815L7.3 6.915L8.1 9.515C8.4 10.515 9.7 10.615 10.2 9.815L11 8.715C11.1 8.615 11.1 8.615 11.2 8.615L12.9 8.515ZM13.9 7.115H11.2C10.6 7.115 10.1 7.415 9.8 7.815L9.3 8.615L8.5 6.115C8.2 5.115 6.9 4.915 6.3 5.715L5.4 7.015C5.4 7.115 5.3 7.115 5.2 7.115H1.8C1.8 7.115 1.8 7.115 1.7 7.115C1.1 5.815 1.4 4.315 2.5 3.315C3.7 2.015 5.8 2.115 7.2 3.615C7.3 3.815 7.5 3.915 7.7 3.915C7.9 3.915 8.2 3.815 8.3 3.715C9.1 2.815 10 2.415 11.2 2.515C12.6 2.615 14 3.915 14.1 5.415C14.3 6.015 14.2 6.615 13.9 7.115Z'
      fill='currentColor'
    />
  </svg>
</template>;

export default WrHeartIconComponent;
